import dayjs from '@/utils/dayjs';

export const getFormattedDate = (date: string | number) => {
  if (!date) return '';

  const isUnix = typeof date === 'number' || (/^\d+$/.test(date) && !isNaN(Number(date)));
  const parsedDate = isUnix ? dayjs.unix(Number(date)) : dayjs(date);

  return parsedDate.isValid() ? parsedDate.tz().format('YYYY-MM-DD HH:mm:ss') : '';
};

export const getFormattedDateISO = (date: string | number) => {
  if (!date) return '';

  const isUnix = typeof date === 'number' || (/^\d+$/.test(date) && !isNaN(Number(date)));
  const parsedDate = isUnix ? dayjs.unix(Number(date)) : dayjs(date);

  return parsedDate.isValid() ? parsedDate.toISOString() : '';
};
